import React, { Component, Fragment } from "react";
import { User, Unlock } from "react-feather";
import { withRouter } from "react-router-dom";
import {
  auth,
  createAdminProfileDocument,
  firestore,
} from "../../firebase/firebase.utils";
import { notifySuccess, notifyWarning, notifyError } from "../../utils/notify";

export class LoginTabset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "login",
      startDate: new Date(),
      loginEmail: "",
      loginPassword: "",
      registerEmail: "",
      registerPassword: "",
      registerConfirmPassword: "",
      registerStatus: "",
      registerDisplayName: "",
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleLoginSubmit = async (event) => {
    event.preventDefault();
    const { loginEmail, loginPassword } = this.state;
    try {
      await auth.signInWithEmailAndPassword(loginEmail, loginPassword);
      this.setState({ loginEmail: "", loginPassword: "" });
      auth.onAuthStateChanged(async (userAuth) => {
        if (userAuth) {
          const adminRef = firestore.doc(`admins/${userAuth.uid}`);
          const snapShot = await adminRef.get();
          if (snapShot.exists) {
            if (
              snapShot.data().activeStatus &&
              snapShot.data().activeStatus === "Inactive"
            ) {
              notifyError("Your account is deactivated");
              return;
            }
            this.props.setCurrentAdmin({ id: snapShot.id, ...snapShot.data() });
            this.props.history.push(`${process.env.PUBLIC_URL}/dashboard`);
          }
        } else {
          notifyError("your email is not authenticated");
        }
      });
    } catch (error) {
      notifyError(error.message || String(error));
    }
  };

  handleRegisterSubmit = async (event) => {
    event.preventDefault();
    const {
      registerEmail,
      registerPassword,
      registerConfirmPassword,
      registerStatus,
      registerDisplayName,
    } = this.state;
    if (registerPassword !== registerConfirmPassword) {
      notifyWarning("passwords don't match");
      return;
    }
    try {
      const { user } = await auth.createUserWithEmailAndPassword(
        registerEmail,
        registerPassword
      );
      await createAdminProfileDocument(user, {
        name: registerDisplayName,
        status: registerStatus,
      });
      this.setState({
        registerDisplayName: "",
        registerEmail: "",
        registerPassword: "",
        registerConfirmPassword: "",
      });
      this.props.history.push("/dashboard");
    } catch (error) {
      notifyError(error.message || String(error));
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    var emailAddress = this.state.loginEmail;
    if (!emailAddress) {
      notifyWarning("Please enter your email address");
      return;
    }
    auth
      .sendPasswordResetEmail(emailAddress)
      .then(() => {
        notifySuccess(
          "Password reset email has been sent to your email address. Please check your email."
        );
      })
      .catch((error) => {
        notifyError(error.message);
      });
    this.setState({ emailAddress: "" });
  };

  render() {
    const { activeTab } = this.state;
    const canRegister =
      this.props.currentAdmin &&
      this.props.currentAdmin.status === "Admin";

    return (
      <div>
        <div className="login-tabs">
          <button
            type="button"
            className={`login-tab-btn${activeTab === "login" ? " active" : ""}`}
            onClick={() => this.setState({ activeTab: "login" })}
          >
            <User size={14} />
            Login
          </button>
          {canRegister && (
            <button
              type="button"
              className={`login-tab-btn${activeTab === "register" ? " active" : ""}`}
              onClick={() => this.setState({ activeTab: "register" })}
            >
              <Unlock size={14} />
              Register
            </button>
          )}
        </div>

        {activeTab === "login" && (
          <form onSubmit={this.handleLoginSubmit}>
            <div className="login-field">
              <label htmlFor="loginEmail">Email address</label>
              <input
                id="loginEmail"
                required
                name="loginEmail"
                value={this.state.loginEmail}
                onChange={this.handleChange}
                type="email"
                className="login-input"
                placeholder="you@example.com"
              />
            </div>
            <div className="login-field">
              <label htmlFor="loginPassword">Password</label>
              <input
                id="loginPassword"
                required
                name="loginPassword"
                value={this.state.loginPassword}
                onChange={this.handleChange}
                type="password"
                className="login-input"
                placeholder="••••••••"
              />
            </div>
            <div className="login-meta-row">
              <label className="login-remember">
                <input type="checkbox" />
                Remember me
              </label>
              <button
                type="button"
                className="login-forgot"
                onClick={(e) => this.handleSubmit(e)}
              >
                Forgot password?
              </button>
            </div>
            <button className="login-submit-btn" type="submit">
              Sign in
            </button>
          </form>
        )}

        {activeTab === "register" && canRegister && (
          <form onSubmit={this.handleRegisterSubmit}>
            <div className="login-field">
              <label>Full name</label>
              <input
                required
                name="registerDisplayName"
                value={this.state.registerDisplayName}
                onChange={this.handleChange}
                type="text"
                className="login-input"
                placeholder="John Doe"
              />
            </div>
            <div className="login-field">
              <label>Email address</label>
              <input
                required
                name="registerEmail"
                value={this.state.registerEmail}
                onChange={this.handleChange}
                type="email"
                className="login-input"
                placeholder="admin@zapai.com.bd"
              />
            </div>
            <div className="login-field">
              <label>Password</label>
              <input
                required
                name="registerPassword"
                value={this.state.registerPassword}
                onChange={this.handleChange}
                type="password"
                className="login-input"
                placeholder="••••••••"
              />
            </div>
            <div className="login-field">
              <label>Confirm password</label>
              <input
                required
                name="registerConfirmPassword"
                value={this.state.registerConfirmPassword}
                onChange={this.handleChange}
                type="password"
                className="login-input"
                placeholder="••••••••"
              />
            </div>
            <div className="login-field">
              <label>Role</label>
              <select
                className="login-select"
                name="registerStatus"
                value={this.state.registerStatus}
                onChange={this.handleChange}
                required
              >
                <option value="">Select role</option>
                <option value="Admin">Admin</option>
                <option value="Accounts">Accounts</option>
                <option value="Employee">Employee</option>
                <option value="Officer">Officer</option>
              </select>
            </div>
            <div className="login-terms">
              <input type="checkbox" required />
              I agree to the{" "}
              <a href="">Terms &amp; Conditions</a>
            </div>
            <button className="login-submit-btn" type="submit">
              Create account
            </button>
          </form>
        )}
      </div>
    );
  }
}

export default withRouter(LoginTabset);
